import IAction from "../store/IAction"
import ICompanyVm from "../models/shared/ICompanyVm"
import { Dispatch } from "redux"
import InitState from "../store/initState"
import * as addressRed from "./addressReducer"
import addressReducer from "./addressReducer"
import IPostalCodeVm from "../models/shared/IPostalCodeVm"
import Api from "../services/api"
import * as metaReducer from "./metaReducer"
import * as applicationsReducer from "./applicationsReducer"
import { CompanyCreateType } from "../models/enums/CompanyCreateType"
import * as applicationForReorderingOfCertificateReducer from "./applicationForReorderingOfCertificateReducer"

const REPLACE_COMPANY = "BAT2/company/REPLACE_COMPANNY"
const UPDATE_COMPANY_REGISTRATION_IDENTIFIER = "BAT2/company/UPDATE_COMPANY_REGISTRATION_IDENTIFIER"
const UPDATE_NAME = "BAT2/company/UPDATE_NAME"
const UPDATE_REFERENCE = "BAT2/company/UPDATE_REFERENCE"
const ADD_COMPANY = "BAT2/companies/ADD_COMPANY"
const REMOVE_COMPANY = "BAT2/companies/REMOVE_COMPANY"

export default function companiesReducer(state: ICompanyVm[] = new InitState().companies, action: IAction): ICompanyVm[] {
    switch (action.type) {
        case ADD_COMPANY:
            return [...state, action.payload]
        case REMOVE_COMPANY:
            return [...state].filter(x => x.id !== action.payload)
        default:
    }

    return state
}

export function companyReducer(state: ICompanyVm = new InitState().company, action: IAction): ICompanyVm {
    if (state === null) {
        return state
    }
    switch (action.type) {
        case UPDATE_COMPANY_REGISTRATION_IDENTIFIER:
            return { ...state, companyRegistrationIdentifier: action.payload }
        case REPLACE_COMPANY:
            return { ...action.payload }
        case UPDATE_NAME:
            return { ...state, name: action.payload }
        case UPDATE_REFERENCE:
            return { ...state, reference: action.payload }
        default:
            return {
                ...state, address: addressReducer(state.address, action)
            }
    }
}
export function updateCompanyRegistrationIdentifier(value: string, id: string) {
    return { type: UPDATE_COMPANY_REGISTRATION_IDENTIFIER, payload: value, id }
}

export function replaceCompany(company: ICompanyVm, invoiceId: string) {
    return async (dispatch: Dispatch<any>) => {
        dispatch({ type: REPLACE_COMPANY, payload: company, id: invoiceId })
        const postalCodes: IPostalCodeVm[] = (window as any).postalCodes
        const cityName = postalCodes.filter((x) => {
            return x.postalCode === company.address.postalCode
        })
        if (cityName.length === 1) {
            dispatch(addressRed.updatePostalDistrict(cityName[0].city, company.address.id))
        }
    }
}

export function updateName(value: string, id: string) {
    return { type: UPDATE_NAME, payload: value, id }
}

export function updateReference(value: string, id: string) {
    return { type: UPDATE_REFERENCE, payload: value, id }
}

export function createCompany(company: ICompanyVm, applicationId?: string, isReorderApplication?: boolean) {
    return async (dispatch: any) => {
        // Call api to create and save company. Set isActive to true
        const res = await Api.shared.createCompanyForOnlinePaymentOrElectronicInvoice({ ...company, isActive: true })

        // If res contains a companyRegistrationIdentifier, we assume company is created successfully
        if (!!res.companyRegistrationIdentifier) {
            dispatch({ type: ADD_COMPANY, payload: res })

            // Set message depending on the created company CompanyCreateType , and show toaster
            const msg = res.companyCreateType === CompanyCreateType.ElectronicInvoice ? "EAN betaler oprettet" : "Anden betaler oprettet"
            dispatch(metaReducer.addToastr({ message: msg, type: "success" }))

            // If applicationId exist, update companyChosenForPayment on application
            if (!!applicationId) {
                dispatch(applicationsReducer.updateCompanyChosenForPayment(res, applicationId))
            }

            // If company is created for a reordering application, call the applicationForReorderingOfCertificateReducer instead
            if (isReorderApplication) {
                dispatch(applicationForReorderingOfCertificateReducer.updateCompanyChosenForPayment(res))
            }

            // Close modal
            dispatch(metaReducer.updateIsCreateNewPayorComponentModalOpen(false))
        }
    }
}

export function removeCompany(company: ICompanyVm) {
    return async (dispatch: any) => {
        // Call api to set company as non-active
        const res = await Api.educationalInstitution.markCompanyAsNonActive(company)

        // If returned company isActive = false, we assume the call was successfull
        if (res.isActive === false) {
            dispatch({ type: REMOVE_COMPANY, payload: res.id })
            dispatch(metaReducer.addToastr({ message: "Betaler fjernet", type: "success" }))
        }
    }
}
